import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import UsableDatePicker from "../../../components/datepicker/UsableDatePicker";
import SearchField from "../../../components/common/searchbox/SearchField";
import { accountsReceivableData } from "../../../locales/en";
import { statusOptions } from "./statusOptions";
import styles from "../../../assets/scss/custom.module.scss";
import "./accountsReceivableStyle.scss";

const { filter } = accountsReceivableData;

/**
 * The one control that changes what the report means is the as-at date. Everything else,
 * the status filter included, only narrows the rows that are already in the report.
 */
function AccountsReceivableFilter({
  selectedAsAtDate,
  handleAsAtDateChange,
  onFilter,
  onDownload,
  loading,
  searchKeyword,
  handleSearchChange,
  handleKeyDown,
  selectedStatuses,
  handleStatusChange
}) {
  return (
    <div className="main-filter-bar flex-wrap mb-3 accounts-receivable-filter">
      <div className="d-flex flex-wrap justify-content-between align-items-center w-100 gap-3 mb-1 mt-1">
        <div className="d-flex flex-wrap align-items-center gap-3">
          <div>
            <label className="d-block mb-1 text-muted fw-bold filter-label">
              {filter.asAtDate}
            </label>
            <UsableDatePicker
              className={styles.filterDate}
              onChange={handleAsAtDateChange}
              value={selectedAsAtDate}
            />
          </div>
          <div className="accounts-receivable-status-filter">
            <label className="d-block mb-1 text-muted fw-bold filter-label">
              {filter.statusLabel}
            </label>
            <Select
              isMulti
              isDisabled={loading}
              name="statuses"
              options={statusOptions}
              value={selectedStatuses}
              onChange={handleStatusChange}
              placeholder={filter.statusPlaceholder}
              className="basic-multi-select ar-status-select"
              classNamePrefix="select"
            />
          </div>
          <div className="d-flex align-items-center gap-2 mt-4">
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={onFilter}
              disabled={loading}
            >
              {filter.filterBtn}
            </button>
            <button
              type="button"
              className="btn btn-success btn-sm excel-btn"
              onClick={onDownload}
              disabled={loading}
            >
              {filter.excelBtn}
            </button>
          </div>
        </div>

        <div className="d-flex align-items-center mt-4">
          <SearchField
            tempSearchQuery={searchKeyword}
            handleSearchChange={handleSearchChange}
            handleKeyDown={handleKeyDown}
            placeHolderText={filter.searchPlaceholder}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
}

AccountsReceivableFilter.propTypes = {
  selectedAsAtDate: PropTypes.any,
  handleAsAtDateChange: PropTypes.func.isRequired,
  onFilter: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  searchKeyword: PropTypes.string,
  handleSearchChange: PropTypes.func,
  handleKeyDown: PropTypes.func,
  selectedStatuses: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      id: PropTypes.number
    })
  ),
  handleStatusChange: PropTypes.func
};

export default AccountsReceivableFilter;
